import get from 'lodash/get';

import { AbstractSpecification } from './specification';

export class StringSpecification<T> extends AbstractSpecification<T> {
   constructor(private search: string, private regex: RegExp, private propertyPath: string) {
      super();
   }

   isSatisfiedBy = (candidate: T | undefined): boolean => {
      if (candidate === undefined) return false;
      const objectProperty = get(candidate, this.propertyPath);
      if (!objectProperty) return false;
      return objectProperty.toString().toLowerCase().replace(this.regex, '').includes(this.search);
   };
}
